import navigation from "@/lang/ms/navigation";
import generics from "@/lang/ms/generics";
import questions from "@/lang/ms/questions";
import a11y from "@/lang/ms/a11y";
import velt from "@/lang/ms/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
